import { render, staticRenderFns } from "./cadastro_edicao_assistente.vue?vue&type=template&id=b3b83622&scoped=true"
import script from "./cadastro_edicao_assistente.vue?vue&type=script&lang=js"
export * from "./cadastro_edicao_assistente.vue?vue&type=script&lang=js"
import style0 from "./cadastro_edicao_assistente.vue?vue&type=style&index=0&id=b3b83622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b83622",
  null
  
)

export default component.exports